import {empionOrangeGradient} from '../../layouts/theme/designSystem';

export enum BackgroundVariant {
  LoggedOut,
  PasswordReset,
  LoggedIn,
}

const VARIANTS: Record<BackgroundVariant, string> = {
  [BackgroundVariant.LoggedOut]: `${empionOrangeGradient.medium}`,
  [BackgroundVariant.PasswordReset]: `${empionOrangeGradient.dark}`,
  [BackgroundVariant.LoggedIn]: `${empionOrangeGradient.base}`,
};

interface Props {
  variant?: BackgroundVariant;
}

export const BackgroundGradient = ({variant = BackgroundVariant.LoggedOut}: Props) => (
  <div
    style={{
      background: VARIANTS[variant],
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: -1,
    }}
  />
);
